import { LegalDocument } from "../models/LegalDocument.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * LegalPageViewModel loads Terms or Privacy copy from `GET /v1/sites/{slug}/content` (#902).
 * Exposes four clean UI states: loading, error (with retry), empty (when no sections), and ready.
 */
export class LegalPageViewModel extends ViewModel {
    client;
    slug;
    kind;
    constructor(client, slug, kind) {
        super({ loading: false, error: null, document: null });
        this.client = client;
        this.slug = slug;
        this.kind = kind;
    }
    async load() {
        await this.run(async () => {
            const content = (await this.client.getSiteContent(this.slug));
            const raw = content.legalPages?.[this.kind];
            if (!raw || !raw.sections || raw.sections.length === 0) {
                this.setState({ document: null });
                return;
            }
            this.setState({ document: new LegalDocument(raw) });
        }, `Failed to load ${this.kind} page.`, { onError: () => ({ document: null }) });
    }
}
//# sourceMappingURL=LegalPageViewModel.js.map